export default function (Vue, options) {

    function rendeElScrollInfo(el, heightRemove) {
        // el.style.overflowY= "auto"
        el.style.height = (document.body.offsetHeight - heightRemove) + 'px'
    }

    Vue.filter('replaceHttps', function (value) {
        return value ? value.replace('https', 'http') : ""
    })

    Vue.directive('scroll-area', {
        bind: function (el, binding, vnode) {
            // document.body.style.overflow = "hidden"
        },
        componentUpdated: function (el, binding, vnode) {
            // console.log(binding.value)
            let heightRemove = 8
            if (binding.value instanceof Array) {
                heightRemove = binding.value.reduce((p, v) => {
                    return p + document.querySelector(v).offsetHeight + 16
                }, 0);
                // console.log(heightRemove)
            }

            rendeElScrollInfo(el, heightRemove)

            let timer = false
            window.addEventListener('resize', () => {
                if (!timer) {
                    timer = true
                    setTimeout(() => {
                        // console.log(1)
                        rendeElScrollInfo(el, heightRemove)
                        timer = false
                    }, 500)
                }
            }, false);
        }
    })

}


// WEBPACK FOOTER //
// ./src/directives/index.js